// ids should be same as in database (mysql-1 cbi_admin_permission.admin_page, dtscs-501.2)
export const SIMILAR_COMPANIES_PERMISSIONS = {
  pageId: 76,
  name: 'Similar Companies',
  path: 'similar-companies',
} as const;
